import IndustrySolutionI18n from "@/components/landing/shared/IndustrySolutionI18n";
import { Clock, Shield, FileCheck, MessageSquare } from "lucide-react";
const LoesungVersicherungSection = () => <IndustrySolutionI18n translationPrefix="industryVersicherung" icons={[Clock, Shield, FileCheck, MessageSquare]} />;
export default LoesungVersicherungSection;
